import { Box, Typography } from '@mui/material';
import * as yup from 'yup';

import AuthModal from 'components/system/AuthModal/AuthModal';
import { LoadingButton } from 'components/system/buttons';
import { FormTextField } from 'components/system/form';
import { useForm } from 'react-hook-form';
import useYupValidationResolver from 'utils/useYupValidationResolver';
import { requiredEmailField } from 'yupHelper';
import { useForgotPassword } from '../hooks/useForgotPassword';
import { SetupAccountModal } from './common/SetupAccountModal';

const validationSchema = yup.object({
  email: requiredEmailField,
});

interface IResetPasswordFormValues {
  email: string;
}

export const ForgotPasswordModal = () => {
  const { loading, handleBackToLogin, handleFormSubmit, prefilledEmail } =
    useForgotPassword();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<IResetPasswordFormValues>({
    resolver: useYupValidationResolver(validationSchema),
    defaultValues: { email: prefilledEmail || '' },
  });

  return (
    <SetupAccountModal open={true} handleBackToLogin={handleBackToLogin}>
      <AuthModal.Content>
        <AuthModal.Title sx={{ marginBottom: 3 }}>
          Forgot Password?
        </AuthModal.Title>
        <Typography variant="textXl" sx={{ marginBottom: 12 }} paragraph>
          No worries, we’ll send you reset instructions. Please enter your email
          account.
        </Typography>
        <Box>
          <FormTextField
            id="email"
            label="Email"
            variant="standard"
            error={errors.email?.message}
            required
            {...register('email')}
          />
        </Box>
      </AuthModal.Content>
      <AuthModal.Buttons>
        <LoadingButton
          onClick={handleSubmit(handleFormSubmit)}
          loading={loading}
        >
          Submit
        </LoadingButton>
      </AuthModal.Buttons>
    </SetupAccountModal>
  );
};
